import { connect } from 'react-redux'
import withDidMountRequest from 'app/connectors/withDidMountRequest'

import {
  getIdentityActivitiesHistorySliced,
  getIdentityPendingGetHistory,
  getIdentityActiveProTrackName,
  isFirstActionFinished,
  isStageIsSelection,
  getCurrentProTrackProgressDay,
} from 'store/entities/identity/selectors'
import { getActivitiesHistory } from 'store/entities/identity/actions'
import { getUIWindowSizesWidth } from 'store/entities/ui/selectors'
import { getPageRagardingCurrentDay } from 'helpers'

import ActivitiesGraph from './ActivitiesGraph'

const mapStateToProps = state => {
  const activities = getIdentityActivitiesHistorySliced(state)
  const activitiesSize = activities.size
  return {
    pending: getIdentityPendingGetHistory(state),
    proTrackName: getIdentityActiveProTrackName(state),
    showStats: !isStageIsSelection(state) && activitiesSize && isFirstActionFinished(state),
    isMobile: getUIWindowSizesWidth(state) < 530,
    currentLevelDay: getCurrentProTrackProgressDay(state),
  }
}

const mergeProps = ({ isMobile, currentLevelDay, ...restState }, { dispatch }, ownProps) => ({
  ...restState,
  ...ownProps,
  onRequest: () => dispatch(getActivitiesHistory({ page: getPageRagardingCurrentDay(currentLevelDay, isMobile), limit: isMobile ? 10 : 20 })),
})

export default connect(mapStateToProps, null, mergeProps)(withDidMountRequest(ActivitiesGraph))
